/**
 * <<uppercase_module_name>> Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import {
    getFePartCategories,
    getFePartCategory,
    printFePartCategory,
    createFePartCategories,
    updateFePartCategories,
    deleteFePartCategories,
} from "Application/modules/configuration/fe_part_categories/config/api.fe_part_categories";

const state = {
    page: {},
    form: {},
    fe_part_categories: [],
    fe_part_category_options: [],
    selectedFePartCategory: {
        category_id: null,
        company_id: "",
        fe_part_category_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        fe_part_category_details: [],
    },
    fe_part_categories_filter: {
        search: "",
        page_size: 2,
        page_num: 1,
    },
    rules_fe_part_categories: {
        category_id: {
            name: "category_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        category_name: {
            name: "category_name",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        category_description: {
            name: "category_description",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    fe_part_categories: (state) => {
        return state.fe_part_categories;
    },
};

// actions
const actions = {
    async fetchFePartCategories({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getFePartCategories({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("mutate", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                if (body.options) {
                    commit("mutate", {
                        property: "fe_part_category_options",
                        with: response.data.fe_part_categories,
                    });
                } else {
                    commit("mutate", {
                        property: "fe_part_categories",
                        with: response.data.fe_part_categories,
                    });
                }

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log(error);
            console.log("fetch all error");
            return;
        }
    },
    async fetchFePartCategory({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getFePartCategory(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("mutate", {
                    property: "selectedFePartCategory",
                    with: response.data.fe_part_category,
                });
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printFePartCategory({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printFePartCategory(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveFePartCategory({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["category_id"] === "undefined" || body["category_id"] == null || body["category_id"] == "") {
                delete body["category_id"];
                response = await createFePartCategories({ body: body, headers: config.headers });
            } else {
                let category_id = body["category_id"];
                delete body["category_id"];
                response = await updateFePartCategories({ body: body, headers: config.headers }, category_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteFePartCategory({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteFePartCategories(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    },
    resetFePartCategories(state) {
        state.page = {};
        state.form = {};
        state.fe_part_categories = [];
        state.fe_part_category_options = [];
        state.selectedFePartCategory = {
            category_id: null,
            company_id: "",
            fe_part_category_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            fe_part_category_details: [],
        };
        state.fe_part_categories_filter = {
            search: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
